import React, { Component, Fragment } from 'react';
import { Grid, CssBaseline, Paper, Box, Typography, TextField, FormControl, InputAdornment, IconButton, InputLabel, FilledInput, Button, LinearProgress, Snackbar } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { BLUE_COLOR, LIGHTGRAY_COLOR, PINK_COLOR } from "../constants";
// import { authenticateUser} from "../actions";
import { Redirect } from 'react-router-dom';
import MuiAlert from '@material-ui/lab/Alert';
import axios from "axios";
import ReactSession from '../reactclient.js';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import { fnPostapiResponse, fnGETapiResponse, Fnencryption, Fndecryption } from '../APICall';
import circulargridimage from '../gallery/gridloader.gif';
import { ColorLensOutlined } from '@material-ui/icons';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export default class Login1 extends Component {
  state = {
    amount: '',
    setopen: false,
    login: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
    redirect: false,
    isAuthenticating: false,
    messagetype: '',
    showsnackbar: false,
    message: '',
    passworderror: false,
    passwordhelpertext: '',
    loginerror: false,
    loginhelpertext: '',
    iswindRadio: false,
    isas400: true,
    logintype: "isas400",
    isloading: "none"


  }
  handleChange(event) {
    this.setState({ password: event.target.value });
  };

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword })
  };

  handleMouseDownPassword(event) {
    event.preventDefault();
  };

  async handleLogin() {
    if (this.state.login != undefined || this.state.password != undefined) {
      //add checkQuote for password by dvlp5 on 25022026
      const checkQuote = (this.state.password.trim().includes('"') || this.state.login.trim().includes('"') || this.state.password.trim().includes("'") || this.state.login.trim().includes("'") || this.state.password.trim().includes("/") || this.state.login.trim().includes("/"))
      if (this.state.login.trim() == "" || this.state.password.trim() == "") {  //add password parameter by dvlp5 on 24022026
        alert("Please Fill Username and Password")
      }
      else if (checkQuote == true) {  //add checkQuote for password by dvlp5 on 25022026
        alert("Invalid username or password")
      }
      else {
        sessionStorage.setItem("AddNewBtnDisable", "")
        if (this.state.iswindRadio) {
          this.setState({
            isloading: "block"
          })
          sessionStorage.setItem('username', this.state.login.toUpperCase());
          sessionStorage.setItem('IsWindowsAuth', true);
          sessionStorage.setItem('password', this.state.password.toLowerCase())

          var logindata = {

            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'IsWindowsUser',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT1 + '',
            "body": {
              "UserName": this.state.login,
              "Password": Fnencryption(this.state.password)
            }
          }
          await fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare1', logindata, process.env.REACT_APP_PORT_MIDDLEWARE).then((response1) => {

            const decrypted = Fndecryption(response1.data);
            //if (response1.data) {
            if (decrypted == "True" && response1.status == 200) {
              this.setState({ redirect: true });
            }
            else {
              alert("Invalid username or password");
              this.setState({
                isloading: "none"
              })
            }
          }).catch((error) => {
            if (error.response.data) {
              // backend returned error (401 / 400 / 500)
              alert(error.response.data.message || "Invalid username or password");
            } else if (error.request) {
              // request sent but no response
              alert("Server not responding. Please try again later.");
            } else {
              // unexpected error
              alert("Unexpected error occurred.");
            }
            this.setState({
              isloading: "none"
            })
          });
        }
        else {
          sessionStorage.setItem('username', this.state.login.toUpperCase());
          sessionStorage.setItem('IsWindowsAuth', false);
          sessionStorage.setItem('password', this.state.password.toLowerCase())
          var data1 =
          {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETLoginCheckNew',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": this.state.login
          }
          await fnGETapiResponse(
            process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
            'GetApiMiddleWare1',
            data1,
            process.env.REACT_APP_PORT_MIDDLEWARE
          )
            .then((response2) => {
              const decrypted = Fndecryption(response2.data.data);
              const decryptedObj = JSON.parse(decrypted);
              // success case (200)
              if (decryptedObj?.success === true && response2.status === 200) {
                if (this.state.smUserVal === true) {
                  sessionStorage.setItem('username1', "SMuser");
                  this.setState({ direction: '/Dashboard', redirect: true });
                } else {
                  sessionStorage.setItem('username1', null);
                  this.setState({ direction: '/Dashboard', redirect: true });
                }
              } else {
                alert(decryptedObj?.message || "Login failed");
              }
            })
            .catch((error) => {
              if (error.response.data.data != undefined) {
                const decrypted = Fndecryption(error.response.data.data);
                const decryptedObj = JSON.parse(decrypted);
                if (error.response.data) {
                  // backend returned error (401 / 400 / 500)
                  alert(decryptedObj.message || "Invalid username or password");
                } else if (error.request) {
                  // request sent but no response
                  alert("Server not responding. Please try again later.");
                } else {
                  // unexpected error
                  alert("Unexpected error occurred.");
                }
              }
              else {
                alert(error.response.data || "Invalid username or password");
              }
            });
        }
      }
    }
    else {
      alert("Please Fill Username and Password")
    }
  }

  componentDidMount() {
    // console.log("Oprating System",window.navigator)
    // console.log("Env Objects",process.env)
    sessionStorage.setItem('IscalledfromOutside', false)
    sessionStorage.setItem('username', '')
    sessionStorage.setItem('isFromWindowApplication', '')
    sessionStorage.setItem('IsWindowsAuth', '')
    sessionStorage.setItem('ClientType', '')
    sessionStorage.setItem('NAME', '')
    sessionStorage.setItem('encrsessionId', '')
    const queryString = require('query-string');
    var parsed = window.location.hash.split('?SessionID=')
    if (parsed.length > 1) {
      console.log("sessionId is = ", parsed[1])
      sessionStorage.setItem('encrsessionId', parsed[1])
      this.getencryptedudsrdetails()
    }

  }
  getencryptedudsrdetails() {
    var data =
    {
      "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
      "MAPINAME": 'UserDetails',
      "MAPIPORT": process.env.REACT_APP_MPORT,
      "body": {
        "SessionId": sessionStorage.getItem('encrsessionId')
      }
    }
    fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
      if (response.data['nuserdtl'] != undefined) {
        console.log("userdetails", response.data['nuserdtl'][0]['USERID'])
        sessionStorage.setItem('username', response.data['nuserdtl'][0]['USERID'])
        sessionStorage.setItem('isFromWindowApplication', true)
        sessionStorage.setItem('IsWindowsAuth', true)
        sessionStorage.setItem('IscalledfromOutside', true)
        this.setState({ redirect: true });
      }
      else { alert(response.data) }
    }).catch(e => console.log(e));
  }
  handleclose() {
    // this.state.setopen=true
  }
  // componentWillReceiveProps(nextProps, nextContext) {
  //   if(nextProps.authentication){
  //
  //     if(nextProps.authentication.strMessage == 'VALID'){
  //       this.setState({isAuthenticating:false,redirect:true,showsnackbar:true,messagetype:'success',message:'Login successful !'});
  //     }else{
  //       //ENTER FAIL STATE
  //       this.setState({isAuthenticating:false,redirect:false,showsnackbar:true,messagetype:'error',message:'Login failed !'});
  //     }
  //   };
  // }
  setLoginType(e) {
    if (e == "Iseries") {
      this.setState({
        iswindRadio: false,
        isas400: true
      })
    }
    else {
      this.setState({
        iswindRadio: true,
        isas400: false
      })
    }
  }
  render() {
    return (
      <Fragment>

        {this.state.redirect &&
          <Redirect to={'AML'} />
        }


        <Grid container component="main" style={{ height: '100vh' }}>
          <CssBaseline />

          <Grid item xs={12} component={Paper}  >
            <div style={{ marginTop: '14vh', marginLeft: '35%' }}>
              <Typography style={{ fontFamily: 'Globerbold', fontSize: 40, textTransform: 'uppercase' }}>login</Typography>
              <Typography style={{ fontFamily: 'Globersemibold', fontSize: 18, marginTop: 15, color: 'gray' }}>Sign in to your ONE SWAN Account</Typography>

              <TextField error={this.state.loginerror} value={this.state.login} onChange={e => this.setState({ login: e.target.value })}
                label="Login" variant={'filled'} style={{ marginTop: 50, width: '50%', fontFamily: 'Globersemibold' }}
                //  add code for 20 charecter length and show validation msg by CDN on 26022026
                inputProps={{ maxLength: 20 }}
                helperText={this.state.login.length == 20 ? "Max 20 characters allowed!" : ''}
                FormHelperTextProps={{
                  style: { color: 'red', fontWeight: 'bold' }
                }}
              />
              <div style={{ height: 5 }} />
              <FormControl variant="filled" style={{ marginTop: 35, width: '50%', fontFamily: 'Globersemibold', backgroundColor: 'rgba(248,248,248,1.0)' }} >
                <InputLabel htmlFor="filled-adornment-password">Password</InputLabel>
                <FilledInput
                  id="filled-adornment-password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  value={this.state.password}
                  error={this.state.passworderror}
                  //  added code for 20 charecter length and show validation msg by CDN on 25022026
                  inputProps={{ maxLength: 20 }}
                  onChange={event => this.handleChange(event)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => this.handleClickShowPassword()}
                        edge="end"
                      >

                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }

                />
                {/* add code for 20 charecter length and show validation msg by CDN on 25022026 */}
                {this.state.password.length === 20 && (
                  <FormHelperText style={{ color: 'red', fontWeight: 'bold' }}>
                    Max 20 characters allowed!
                  </FormHelperText>
                )}
              </FormControl>
              <Grid item xs>
                <RadioGroup row aria-label="" name="v" >
                  <FormControlLabel value="Iseries" onClick={e => this.setLoginType(e.target.value)} checked={this.state.isas400} control={<Radio color={BLUE_COLOR} />} label="Iseries & Windows" />
                  <FormControlLabel value="windows" onClick={e => this.setLoginType(e.target.value)} checked={this.state.iswindRadio} control={<Radio color={BLUE_COLOR} />} label="Windows Only" />
                </RadioGroup>

              </Grid>
              <div style={{ height: 10 }} />
              <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '50%', fontSize: 18 }} onClick={() => this.handleLogin()}>
                login to your account
              </Button>
              <div style={{ height: 35 }} />
              <img style={{ width: "100px", marginLeft: "160px", display: this.state.isloading }} src={circulargridimage} alt="circulargridimage" />


              {/*<Button variant={'text'} style={{color:BLUE_COLOR,fontFamily:'Globerbold',backgroundColor:'transparent',fontSize:18,marginLeft:-8}}>*/}
              {/*    forgot password*/}
              {/*</Button>*/}
              {/*<div style={{height:30}}/>*/}
              {/*<Typography style={{fontFamily:'Globerbold',fontSize:22}}>Cannot login ?</Typography>*/}
              {/*<div style={{height:20}}/>*/}

              {/*<div style={{display:'flex'}}>*/}
              {/*    <Button variant={'text'} style={{color:PINK_COLOR,fontFamily:'Globerbold',backgroundColor:'transparent',fontSize:18,marginLeft:-8}}>*/}
              {/*        register*/}
              {/*    </Button>*/}
              {/*    <Typography style={{fontFamily:'Globersemibold',fontSize:18,color:'gray',marginTop:7}}>to have access to your account</Typography>*/}
              {/*</div>*/}
              {/* <Grid item xs>
                            <RadioGroup aria-label="" name="v" >
        <FormControlLabel value="Windows" control={<Radio color={BLUE_COLOR}/>} label="Iseries & Windows" />
        <FormControlLabel value="Iseries" control={<Radio color={BLUE_COLOR} />} label="Windows Only" />
      </RadioGroup>
                            </Grid> */}
              {this.state.isAuthenticating && <div>
                <Typography
                  style={{ fontFamily: 'Globerbold', fontSize: 18, marginTop: 15, color: BLUE_COLOR }}>Please
                  wait ...</Typography>
                <div style={{ height: 15 }} />
                <LinearProgress color="primary" style={{ width: '50%' }} />
              </div>}
            </div>
          </Grid>
          <Snackbar open={this.state.setopen} autoHideDuration={3000} onClose={this.handleclose()}>
            <Alert style={{ fontWeight: 'bold', fontSize: 18 }} onClose={this.handleclose()} severity={this.state.messagetype}>
              Pankaj
            </Alert>
          </Snackbar>

        </Grid>
      </Fragment>
    )
  }
}

// const mapStateToProps = (data) => {
//   return data;
// };

// export default connect(mapStateToProps, {
//   authenticateUser
// })(Login);
